import React from "react";

// Simple controlled tab bar. Usage:
//   <Tabs tabs={[{key:'profile', label:'Profile'}, ...]} active={tab} onChange={setTab} />
//   {tab === 'profile' && <ProfilePane .../>}
const Tabs = ({ tabs, active, onChange }) => (
  <div className="flex gap-1 border-b border-gray-200 overflow-x-auto">
    {tabs.map((t) => (
      <button
        key={t.key}
        type="button"
        onClick={() => onChange(t.key)}
        className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition ${
          active === t.key
            ? "border-indigo-600 text-indigo-600"
            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
        }`}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default Tabs;
